import { MeetHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const GetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsData = (orgUnitAthleteEntryId, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const orgUnitAthleteEntryIdForUrl = orgUnitAthleteEntryId ? encodeURIComponent(orgUnitAthleteEntryId) : 'NaN';
    const url = `/OrgUnitNonAthleteEntry/orgUnitAthleteEntry/${orgUnitAthleteEntryIdForUrl}/credentials`;

    MeetHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsData;